<template>
  <div class="columns is-vcentered">

    <div class="column is-narrow">
      <sc-field label="Período">
        <sc-range-date-picker
          v-model="filters.dateRange"
          :max-date="maxDate"
          :minDate="limitMinDate"/>
      </sc-field>
    </div>

  </div>
</template>

<script>
  import {
    ScField,
    ScSelect,
    ScRangeDatePicker,
    ScState,
  } from '@intelipost-js/secure-components';

  export default {
    name: 'sc-report-delivered-provider-filters',
    props: {
      filters: {
        type: Object,
        required: true,
      },
      limitMinDate: Date,
      maxDate: Date,
    },
    data() {
      return {
        visionsList: [
          {
            label: 'Data - Cliente',
            value: 'user',
          },
          {
            label: 'Data - Transportadora',
            value: 'logistic_provider',
          },
        ],
        periodsList: [
          {
            label: 'Data de criação',
            value: 'CREATED_DATE',
          },
          {
            label: 'Data prevista',
            value: 'ESTIMATED_DATE',
          },
          {
            label: 'Data de entrega',
            value: 'DELIVERED_DATE',
          },
        ],
      };
    },
    watch: {
      'createdDate.start': () => {
        if (!this.disableSearch) {
          this.clearSelect();
        }
      },
      'createdDate.end': () => {
        if (!this.disableSearch) {
          this.clearSelect();
        }
      },
    },
    components: {
      ScField,
      ScSelect,
      ScRangeDatePicker,
      ScState,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/delivered-provider/components/sc-report-delivered-provider-filters/ScReportDeliveredProviderFilters.vue